import { createSlice } from "@reduxjs/toolkit";
import { getUsers } from "../actions/adminUserManagement.action";
import { InitialState } from "../interfaces/userManagement.interface";

const initialState: InitialState = {
  isLoading: false,
  data: null,
};

const getAdminUsers = createSlice({
  name: "Get User",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUsers.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getUsers.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    builder.addCase(getUsers.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default getAdminUsers.reducer;
